import Bind from 'bind.js';

export default class SideBySideTextMedia {
  constructor(options) {
    this.parentElement = options.parentElement;
    this.data = options.data;
    this.addContent();
  }

  addContent() {
    let template = `
    <div class="sidebyside_text_media">
      <div class="span6 copy">
        <div class="title"></div>
        <div class="para para1"></div>
        <div class="para para2"></div>
        <div class="para para3"></div>
      </div>
      <div class="span6 col media">
        <span class="image"></span>
        <span class="video"></span>
      </div>
    </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        title: this.data.get('title'),
        paragraph1: this.data.get('paragraph1'),
        paragraph2: this.data.get('paragraph2'),
        paragraph3: this.data.get('paragraph3'),
        image: this.data.get('image'),
        video: this.data.get('video')
      },
      {
        title: '.sidebyside_text_media .title',
        paragraph1: '.sidebyside_text_media .para1',
        paragraph2: '.sidebyside_text_media .para2',
        paragraph3: '.sidebyside_text_media .para3',
        image: {
          dom: '.sidebyside_text_media .image',
          transform: function(v) {
            return '<img src="' + v + '"/>';
          }
        },
        video: {
          dom: '.sidebyside_text_media .video',
          transform: function(v) {
            return `<iframe width="100%" height="270px" src="` + v + `"
                            frameborder="0" allowfullscreen></iframe>`;
          }
        }
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.title = data.get('title');
    this.editor.paragraph1 = data.get('paragraph1');
    this.editor.paragraph2 = data.get('paragraph2');
    this.editor.paragraph3 = data.get('paragraph3');
    this.editor.image = data.get('image');
    this.editor.video = data.get('video');
  }
}



// WEBPACK FOOTER //
// ./src/renderers/SideBySideTextMedia.js